import {PhotoFile} from 'react-native-vision-camera';

/* eslint-disable no-shadow */
export type WebViewParams = {uri?: string; onReload?: Function} | undefined;

export interface ApiState<T> {
  loading: boolean;
  error: Error | undefined;
  data?: T | null;
}

export enum OrderItemStatus {
  notPicked = 'notPicked',
  picked = 'picked',
  dropped = 'dropped',
  packed = 'packed',
  notPacked = 'notPacked',
  missing = 'missing',
  requestRejectedByUser = 'requestRejectedByUser',
}

export enum APIV1Version {
  V100 = 'V100',
  V101 = 'V101',
}

export enum SubstitutionRequestStatus {
  pending = 'pending',
  approved = 'approved',
  rejected = 'rejected',
  expired = 'expired',
  cleared = 'cleared',
  cancelled = 'cancelled',
}

export enum InputType {
  email = 'email',
  name = 'name',
  text = 'text',
  radio = 'radio',
  checkbox = 'checkbox',
}

export enum HiringApplicationState {
  submitted = 'submitted',
  rejected = 'rejected',
  interview = 'interview',
  offered = 'offered',
  accountSetup = 'accountSetup',
  completed = 'completed',
  notSubmitted = 'notSubmitted',
}

export enum CTAIntentType {
  navAction = 'navAction',
  deeplink = 'deeplink',
}

export type ImageParams =
  | {imageUrl?: string; persistZoom?: boolean; isMap?: boolean}
  | undefined;

export interface CameraComponentState {
  fileData?: PhotoFile;
  base64: string;
  blob: Blob;
}

export enum StoreType {
  MeijerLincolnPark = '872',
  MeijerBelleville = '871',
}

export enum ClientType {
  meijer = 'meijer',
  buncha = 'buncha',
}

export const StoreNames: Record<string, string> = {
  [StoreType.MeijerLincolnPark]: 'Meijer Lincoln Park',
  [StoreType.MeijerBelleville]: 'Meijer Belleville',
};

export const getStoreName = (storeId: string): string | undefined => {
  return StoreNames[storeId];
};

export const getClientType = (isB2B: boolean): ClientType => {
  if (isB2B) return ClientType.meijer;

  return ClientType.buncha;
};
